// JSON-LD structured data builders for SEO / answer-engine optimization (AEO).
// Kept truthful: no aggregateRating or review counts (no real reviews yet),
// and only the live free tier is exposed as an Offer.

const SITE_URL = 'https://rewordgenie.com';

export const organizationSchema = {
  '@type': 'Organization',
  '@id': `${SITE_URL}/#organization`,
  name: 'RewordGenie',
  url: SITE_URL,
  logo: `${SITE_URL}/logo192.png`,
  description:
    'AI-powered social media content platform that helps marketing teams create on-brand posts in seconds.',
};

export const websiteSchema = {
  '@type': 'WebSite',
  '@id': `${SITE_URL}/#website`,
  url: SITE_URL,
  name: 'RewordGenie',
  publisher: { '@id': `${SITE_URL}/#organization` },
  inLanguage: ['en', 'sl'],
};

export const softwareAppSchema = {
  '@type': 'SoftwareApplication',
  '@id': `${SITE_URL}/#software`,
  name: 'RewordGenie',
  applicationCategory: 'BusinessApplication',
  operatingSystem: 'Web',
  url: SITE_URL,
  description:
    'Generate on-brand social media captions and designs with AI, then publish to Facebook — built for marketing teams and agencies.',
  offers: {
    '@type': 'Offer',
    price: '0',
    priceCurrency: 'USD',
    description: 'Free plan — 5 AI generations per day',
  },
};

/**
 * Build an FAQPage schema from the visible FAQ items so the structured data
 * always matches the rendered content (Google policy requirement).
 *
 * @param {Array<{question: string, answer: string}>} items
 */
export function buildFaqSchema(items = []) {
  return {
    '@type': 'FAQPage',
    '@id': `${SITE_URL}/#faq`,
    mainEntity: items.map(({ question, answer }) => ({
      '@type': 'Question',
      name: question,
      acceptedAnswer: { '@type': 'Answer', text: answer },
    })),
  };
}

/**
 * Compose the full @graph for the landing page.
 */
export function buildHomeJsonLd(faqItems = []) {
  return {
    '@context': 'https://schema.org',
    '@graph': [
      organizationSchema,
      websiteSchema,
      softwareAppSchema,
      buildFaqSchema(faqItems),
    ],
  };
}
